export default __webpack_public_path__ + "4b3b91f10f0e2548a935791829d84b94.png";